/**
 * Logo functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class Logo {
  /**
   * Constructs a new Logo instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    // const cookieExists = Cookies.get('allowed_entry_live')

    // if ( document.body.classList.contains('home') ) {
    //   this.element.addEventListener('transitionend', () => {
    //     if (!document.body.classList.contains('show-age-verification')) {
    //       if (cookieExists) {
    //         document.body.classList.add('play-home-animation')
    //       } else {
    //         document.body.classList.add('show-age-verification');
    //       }
    //     }
    //   })
    // }

  }
}



// WEBPACK FOOTER //
// ./components/logo/index.js